import apiClient from './client';

// Get all campaigns
export const getCampaigns = async () => {
  const response = await apiClient.get('/campaigns/');
  return response.data?.results ?? response.data ?? [];
};

// Get campaign by ID
export const getCampaign = async (campaignId) => {
  const response = await apiClient.get(`/campaigns/${campaignId}/`);
  return response.data;
};

// Get messages sent for one campaign
export const getCampaignMessages = async (campaignId) => {
  const response = await apiClient.get(`/campaigns/${campaignId}/messages/`);
  return response.data?.results ?? response.data ?? [];
};

// Create new campaign
export const createCampaign = async (payload) => {
  const isFormData = payload instanceof FormData;
  const config = isFormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {};
  const response = await apiClient.post('/campaigns/create/', payload, config);
  return response.data;
};

// Update campaign
export const updateCampaign = async (campaignId, payload) => {
  const isFormData = payload instanceof FormData;
  const config = isFormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {};
  const response = await apiClient.patch(`/campaigns/${campaignId}/`, payload, config);
  return response.data;
};

// Delete campaign
export const deleteCampaign = async (campaignId) => {
  const response = await apiClient.delete(`/campaigns/${campaignId}/`);
  return response.data;
};

// Get running campaigns
export const getRunningCampaigns = async () => {
  const response = await apiClient.get('/campaigns/running/');
  return response.data?.results ?? response.data ?? [];
};

// Get campaign history (completed/failed campaigns)
export const getCampaignHistory = async () => {
  const response = await apiClient.get('/campaigns/history/');
  return response.data?.results ?? response.data ?? [];
};

// Get scheduled campaigns
export const getScheduledCampaigns = async () => {
  const response = await apiClient.get('/campaigns/scheduled/');
  return response.data?.results ?? response.data ?? [];
};



// Launch (send) a campaign
export const launchCampaign = async (campaignId, payload = {}) => {
  const isFormData = payload instanceof FormData;
  const config = isFormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {};
  const response = await apiClient.post(`/campaigns/${campaignId}/launch/`, payload, config);
  return response.data;
};

// Schedule a campaign for later
export const scheduleCampaign = async (campaignId, scheduledAt) => {
  const response = await apiClient.post(`/campaigns/${campaignId}/schedule/`, { scheduled_at: scheduledAt });
  return response.data;
};

// Stop a campaign and move it to history
export const stopCampaign = async (campaignId) => {
  const response = await apiClient.post(`/campaigns/${campaignId}/stop/`);
  return response.data;
};

// Complete a campaign
export const completeCampaign = async (campaignId) => {
  const response = await apiClient.post(`/campaigns/${campaignId}/complete/`);
  return response.data;
};

// Save entire campaign as draft manually
export const createDraftCampaign = async (payload) => {
  const response = await apiClient.post('/create/draft/', payload);
  return response.data;
};

// Create campaign and immediately launch (or schedule if scheduled_at is set)
export const launchCampaignNew = async (payload) => {
  const response = await apiClient.post('/create/crm_launch/', payload);
  return response.data;
};

// Get public campaign details by user name and campaign name
export const getPublicCampaignDetail = async (userName, campaignName) => {
  const response = await apiClient.get(`/public/campaign/${encodeURIComponent(userName)}/${encodeURIComponent(campaignName)}/`);
  return response.data;
};

// Submit lead for a public campaign
export const submitPublicCampaignLead = async (payload) => {
  const response = await apiClient.post('/public/campaign/submit-lead/', payload);
  return response.data;
};

